import React, { Fragment } from "react";
import OTPInput, { ResendOTP } from "otp-input-react";
import Notification from "../../../Notification";
import "./styles.css";
import { getLabel } from "../../../../hooks/use-labels";

const Otp = ({
  otpVal,
  onChange,
  errorMessage,
  otpLength,
  resendOtp,
  resendOtpTime,
}) => {
  const renderButton = (props) => {
    const { remainingTime, ...rest } = props;
    return (
      <button {...rest}>
        {remainingTime !== 0 ? (
          `${getLabel("resendCodeText")} 0:${
            remainingTime < 10 ? `0${remainingTime}` : remainingTime
          }.`
        ) : (
          <div onClick={() => resendOtp(true)}>Resend</div>
        )}
      </button>
    );
  };

  const renderTime = (remainingTime) => {
    return (
      <span style={{ display: "none" }}>{remainingTime} seconds remaining</span>
    );
  };

  return (
    <Fragment>
      {errorMessage && <Notification type="danger" message={errorMessage} />}
      <OTPInput
        value={otpVal}
        onChange={onChange}
        autoFocus
        OTPLength={otpLength}
        otpType="number"
        disabled={false}
        placeholder={["*", "*", "*", "*", "*", "*"]}
        inputClassName="otp-input-class"
        className="otp-content-class"
      />
      <ResendOTP
        renderButton={renderButton}
        renderTime={renderTime}
        maxTime={resendOtpTime}
        className="authentication__otp-resend"
        style={{ justifyContent: "center", marginTop: "24px" }}
      />
    </Fragment>
  );
};

export default Otp;
